
import React from "react";
import LogoDark from "../assets/acebit-logo-white.svg";

import DesktopTopbar from "./topbardesktop"
import ColorToggle from "./colortoggle";
import Hamburger from "./Hamburger";
import NavLink from "./navlink";

const Topbar = (props) => {

  const menuItems = [
    { target: "about", title: "Om Oss" },
    { target: "offer", title: "Erbjudande" },
    { target: "naas", title: "As a Service" },
    { target: "career", title: "Karriär" },
    { target: "contact", title: "Kontakt" },
  ]

  const windowSize = props.windowSize

  return (
    <>
      <header className="sticky top-0 text-white bg-gray_transparent dark:text-white backdrop-blur-sm z-20 h-16">

        {/* Desktop menu */}
        <div className="flex justify-between p-4">
          <div className="flex items-center justify-start">
            <div className="flex-2 px-4">
              <NavLink target="home">
                <img src={LogoDark} alt="Logo" width={100} />
              </NavLink>
            </div>
          </div>
          <div className="flex items-center justify-end gap-4">
            {windowSize.width >= 600 ? <DesktopTopbar links={menuItems} /> : <Hamburger links={menuItems} />}
            <ColorToggle />
          </div>
        </div>
      </header>
    </>
  );
};

export default Topbar;